import {Injectable} from '@angular/core';
import {WizardNestedFormService} from '../abstract/wizard-nested-form-service';
import {FormBuilder, Validators} from '@angular/forms';
import {WizardFormEventsService} from '../wizard-form-events.service';
import {WizardValidators} from '../../wizard-validators';
import {distinctUntilChanged, filter, map, takeUntil} from 'rxjs/operators';
import {combineLatest} from 'rxjs';
import {BusinessStructureProvider} from '@providers/business-structure/business-structure.provider';

@Injectable()
export class ResultService extends WizardNestedFormService {
    form = this.fb.group({
        _touched: [false, Validators.requiredTrue],

        /**
         * Кто заполнял
         */
        editor: ['', [
            WizardValidators.required(
                `Возможно нам придется с вами связаться, поэтому это поле обязательное. Заполните и попробуйте снова.`,
                false)
        ]],

        phone: ['', [
            WizardValidators.required(
                `Возможно нам придется с вами связаться, поэтому это поле обязательное. Заполните и попробуйте снова.`,
                false),
            WizardValidators.requiredLength(18, 'Введенные данные не полные, укажите мобильный телефон полностью.')
        ]],

        email: ['', [
            WizardValidators.required(
                `Возможно нам придется с вами связаться, поэтому это поле обязательное. Заполните и попробуйте снова.`,
                false),
            WizardValidators.email()
        ]],

        /**
         * Проверять ли пакет документов специалистами Лаборатории 365
         */
        validate_by_lab365: [false],

        /**
         * Другой способ оплаты?
         */
        anotherPayment: [false],

        /**
         * Название организации для оплаты
         */
        payment_organization_name: ['', [
            WizardValidators.required(
                `Наименование организации потребуется для выставления счета на оплату. Заполните поле и попробуйте снова.`,
                false),
        ]],

        /**
         * ИНН для оплаты
         */
        payment_inn: ['', [
            WizardValidators.required(
                `ИНН организации на которую необходимо выставить счет на оплату является обязательным полем.
                        Заполните и попробуйте снова.`,
                false),
            WizardValidators.requiredLength(10,
                'ИНН юридического лица состоит из 10 цифр, перепроверьте введеные данные и попробуйте снова.')
        ]],
    });

    constructor(
        private fb: FormBuilder,
        private wizardFormEvents: WizardFormEventsService,
        private businessStructureProvider: BusinessStructureProvider,
    ) {
        super();
    }

    init() {
        this.form.get('anotherPayment').valueChanges.pipe(
            map(v => Boolean(v))
        ).subscribe((isAnother) => {
            if (isAnother) {
                this.form.get('payment_organization_name').disable();
                this.form.get('payment_inn').disable();
            } else {
                this.form.get('payment_organization_name').enable();
                this.form.get('payment_inn').enable();
            }
        });

        if (this.isFormTouched()) {
            return;
        }

        combineLatest(
            this.wizardFormEvents.organizationBusinessStructureId$.pipe(
                map(id => this.businessStructureProvider.getById(id)),
                filter(v => Boolean(v && v.short_title)),
                map(value => value.short_title)
            ),
            this.wizardFormEvents.organizationTitle$
        ).pipe(
            takeUntil(this.stopSubscribe$)
        ).subscribe((value: string[]) => {
            this.form.get('payment_organization_name').patchValue(value.join(' '));
        });

        this.wizardFormEvents.organizationInn$.pipe(
            takeUntil(this.stopSubscribe$)
        ).subscribe(value => {
            this.form.get('payment_inn').patchValue(value);
        });

        this.form.get('_touched').valueChanges.pipe(
            filter(v => Boolean(v)),
            takeUntil(this.stopSubscribe$)
        ).subscribe(() => {
            this.stopSubscribe$.next();
        });
    }

    restoreValidators() {

    }
}
